import { useEffect, useState } from "react";
import { Col, Row, message, notification, Select } from "antd";
import { Link, useNavigate } from "react-router-dom";
import { Sessions, getSigner } from "@/utils";
import { useAccountState, useAppDispatch } from "@/store";
import { RoutePaths } from "@/router";
import { Actions } from "@/store/reducers/account";
import { getRandomNum, loginApi } from "@/services";
import { useTranslation } from "react-i18next";
import { Wallet } from "@/components/Icons";
import logo from "@/assets/logo.png";
import { Consumer } from "@/App";

type UserInfo = {
  address: string;
};

const Header = () => {
  const { t, i18n } = useTranslation();
  const [collectionId, setCollectionId] = useState(1);
  const accountState = useAccountState();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const [userType, setUserType] = useState();
  const [user, setUser] = useState<UserInfo>();

  useEffect(() => {
    if (Sessions.read("mateKey")) {
      setUser({ address: Sessions.read("mateKey") as string });
    }
  }, []);

  async function connectWallet() {
    await metaMaskPay();
  }

  async function metaMaskPay() {
    let signer = await getSigner();
    if (signer) {
      const res01 = await getRandomNum();
      let ethAddress = await signer.getAddress();
      let chainId = await signer.getChainId();
      if (res01.data) {
        let signature = await signer.signMessage(res01.data.randomCode);
        // jwt
        const res02 = await loginApi({
          randomCodeToken: res01.data.randomCodeToken,
          signatureData: signature,
          walletAddress: ethAddress,
        });
        if (res02.data) {
          if (res02.data.avatar) {
            navigate(RoutePaths.HOME);
            message.info(t("msg.COM_1"));
          } else {
            if (res02.data.userType == 3) {
              navigate(RoutePaths.PROFILE_IPHOLDER);
              message.info(t("msg.COM_1"));
            } else if (res02.data.userType == 2) {
              navigate(RoutePaths.PROFILE);
              message.info(t("msg.COM_1"));
            } else {
              navigate(RoutePaths.MY_PAGE);
            }
          }
          dispatch(
            Actions.login({
              address: ethAddress,
              chain: chainId,
              isMetamask: true,
              userId: res02.data ? res02.data.userId : null,
              avatar: res02.data.avatar ? res02.data.avatar : null,
              avatarUrl: res02.data.avatarUrl ? res02.data.avatarUrl : null,
              userName: res02.data.userName ? res02.data.userName : null,
              userDetails: res02.data.userDetails ? res02.data.userDetails : null,
              jpnft: res02.data.jpnft,
              email: res02.data.email,
              userType: res02.data ? res02.data.userType : null,
              twitterUrl: res02.data.twitterUrl ? res02.data.twitterUrl : null,
              linktreeUrl: res02.data.linktreeUrl ? res02.data.linktreeUrl : null,
              openseaUrl: res02.data.openseaUrl ? res02.data.openseaUrl : null,
            })
          );
        } else {
          notification.warning({
            message: t("msg.COM_2"),
          });
        }
      }
    }
  }

  const handleChange = (value: number) => {
    setCollectionId(value);
    if (value == 1) {
      onChangeToJP();
    } else if (value == 2) {
      onChangeToEN();
    } else {
      onChangeToZH();
    }
  };

  const onChangeToJP = () => {
    i18n.changeLanguage("ja");
    dispatch(
      Actions.update({
        locale: "ja",
      })
    );
  };

  const onChangeToEN = () => {
    i18n.changeLanguage("en");
    dispatch(
      Actions.update({
        locale: "en",
      })
    );
  };

  const onChangeToZH = () => {
    i18n.changeLanguage("zh");
    dispatch(
      Actions.update({
        locale: "zh",
      })
    );
  };

  return (
    <Consumer>
      {(ctx) => (
        <header>
          <div className="fixed top-0 w-full pt-2 z-50 bg-white">
            {/* {window.innerWidth < 480 && (
              <div className="text-center pb-2" style={{ color: "red", fontSize: "14px" }}>
                {t("msg.COM_10")}
              </div>
            )} */}
            <Row className="main-container text-center" style={{ textAlign: "center" }}>
              <Col className="gutter-row text-left" span={9}>
                <Link to={RoutePaths.HOME}>
                  <div className="fs_h3">
                    <img className="w-32" src={logo} />
                  </div>
                </Link>
              </Col>
              <Col className="gutter-row text-right text-black" style={{ userSelect: "text" }} span={15}>
                <div className="text-xs items-center justify-end flex">
                  {/*<div*/}
                  {/*    className="bg-white transition duration-200 cursor-pointer inline-block border-solid border-white rounded-l-full p-3 hover:bg-black hover:text-white font-semibold"*/}
                  {/*    style={{border: "2px black solid"}}*/}
                  {/*    onClick={() => navigate(RoutePaths.INQUIRY)}>*/}
                  {/*    <span>お問い合わせ</span>*/}
                  {/*</div>*/}

                  {ctx.width > 768 && <div style={{ userSelect: "text" }} className="inline-block pl-3 pr-14 justify-center items-center">
                    <Link to={RoutePaths.IP_LIST} className="fs_18_bold">
                      {t("page.HOME_ip-listings")}
                    </Link>
                  </div>}

                  {/* <div className="inline-block p-3">
                            <span className='fs_16_bold'> {t("homeWorkList")} </span>
                        </div> */}

                  <div className="felx w-auto justify-end items-center header_select">
                    <div>
                    <svg
                      className="inline-block header_svg -mr-3 md:mr-0"
                      xmlns="http://www.w3.org/2000/svg"
                      width="20.975"
                      height="20.975"
                      viewBox="0 0 20.975 20.975">
                      <path
                        id="シェイプ_1021"
                        data-name="シェイプ 1021"
                        d="M1249.848,66.259c0-.009.005-.017.005-.026s-.007-.026-.008-.04c-.005-.269-.018-.536-.043-.8-.009-.091-.023-.18-.034-.27-.029-.242-.065-.483-.11-.721-.018-.094-.039-.187-.059-.28q-.077-.351-.179-.694c-.026-.086-.05-.172-.078-.257-.076-.235-.163-.467-.256-.7-.029-.073-.056-.147-.087-.219-.108-.249-.227-.494-.355-.735-.025-.047-.045-.1-.071-.142q-.222-.4-.482-.792c-.086-.129-.181-.25-.272-.375-.08-.109-.153-.22-.238-.326-.005-.006-.013-.009-.018-.015a10.466,10.466,0,0,0-8.107-3.962c-.017,0-.032,0-.049,0h-.044a10.466,10.466,0,0,0-8.2,3.966c-.005.006-.013.009-.018.015-.084.106-.157.217-.236.325-.092.125-.187.247-.273.376q-.259.387-.481.791c-.027.049-.049.1-.075.149-.126.239-.245.482-.351.729-.031.072-.058.146-.087.219-.093.229-.179.461-.255.7-.027.085-.052.171-.078.257q-.1.343-.179.693c-.021.094-.042.187-.06.282-.046.238-.081.477-.11.719-.011.091-.025.18-.034.271-.025.269-.038.54-.043.813,0,.01-.006.018-.006.028s0,.012,0,.018c0,.046-.006.091-.006.138a10.429,10.429,0,0,0,2.256,6.478c.007.009.008.02.015.028s.03.032.043.049a10.558,10.558,0,0,0,1.57,1.583c.113.093.233.174.35.262.172.128.344.256.523.374.146.1.3.184.448.272s.325.187.492.274.322.16.485.234.348.15.525.219c.162.063.324.125.489.179.2.065.394.119.594.172.154.041.307.085.464.119.234.051.474.087.713.122.129.019.256.045.386.059a10.534,10.534,0,0,0,1.134.064h.044c.017,0,.032,0,.049,0q.527,0,1.041-.059c.131-.014.258-.041.388-.059.239-.035.478-.071.711-.122.157-.034.311-.079.466-.12.2-.053.4-.107.592-.172.167-.055.329-.117.493-.181s.35-.14.521-.217.328-.153.489-.236.327-.177.487-.271.3-.178.452-.275c.178-.117.348-.243.518-.37.119-.089.24-.172.355-.266a10.559,10.559,0,0,0,1.569-1.582c.014-.017.03-.032.043-.049s.008-.02.015-.029a10.427,10.427,0,0,0,2.256-6.478C1249.853,66.345,1249.848,66.3,1249.848,66.259Zm-2.992,5.206a11.319,11.319,0,0,0-2.47-1.186,19.811,19.811,0,0,0,.358-3.328h3.645A8.994,8.994,0,0,1,1246.855,71.464Zm-.976,1.193c-.13.136-.267.263-.4.39-.09.083-.179.168-.273.248-.12.1-.245.195-.37.29s-.235.183-.358.268c-.1.072-.214.135-.321.2-.148.093-.294.188-.447.272-.091.05-.186.092-.279.139-.173.087-.345.177-.525.253-.087.037-.177.065-.265.1l-.027.01a11.009,11.009,0,0,0,1.435-3.156,9.891,9.891,0,0,1,1.906.906C1245.927,72.6,1245.9,72.632,1245.88,72.658Zm-10.055,2.061c-.174-.075-.342-.161-.51-.246-.1-.049-.2-.093-.294-.146-.148-.081-.289-.174-.432-.263-.112-.071-.227-.137-.337-.212s-.23-.171-.344-.258c-.129-.1-.26-.2-.384-.3-.089-.076-.174-.158-.26-.236-.142-.131-.282-.262-.416-.4-.023-.024-.045-.05-.068-.075a9.979,9.979,0,0,1,1.984-.935,10.974,10.974,0,0,0,1.473,3.228l-.131-.048C1236.012,74.787,1235.917,74.758,1235.825,74.719Zm-5.483-7.769h3.731a19.811,19.811,0,0,0,.353,3.3,11.362,11.362,0,0,0-2.551,1.214A9,9,0,0,1,1230.342,66.95Zm.11-2.085a8.925,8.925,0,0,1,.23-1.014c.014-.049.023-.1.038-.147a8.89,8.89,0,0,1,.422-1.076c.042-.091.086-.182.131-.271a9.016,9.016,0,0,1,.6-1.035,11.386,11.386,0,0,0,2.554,1.215,19.588,19.588,0,0,0-.344,2.979h-3.7c.01-.106.01-.214.023-.318S1230.433,64.975,1230.452,64.865Zm17-2.511c.046.091.09.182.133.275a8.826,8.826,0,0,1,.421,1.074c.015.049.025.1.039.152a8.89,8.89,0,0,1,.229,1.01c.019.11.036.22.051.331s.013.213.023.318h-3.617a19.582,19.582,0,0,0-.348-3,11.317,11.317,0,0,0,2.472-1.189A9.04,9.04,0,0,1,1247.457,62.354Zm-8.809,7.13a15.847,15.847,0,0,0-2.837.37,18.4,18.4,0,0,1-.3-2.9h3.14Zm0,1.432v4.318c-.967-.5-1.9-1.93-2.5-3.984A14.447,14.447,0,0,1,1238.648,70.916Zm1.436,4.363V70.916a14.38,14.38,0,0,1,2.583.352C1242.051,73.373,1241.078,74.818,1240.084,75.279Zm0-5.8V66.95h3.225a18.383,18.383,0,0,1-.306,2.925A15.831,15.831,0,0,0,1240.084,69.484Zm3.217-3.97h-3.217V63.3a15.814,15.814,0,0,0,2.918-.4A18.169,18.169,0,0,1,1243.3,65.514Zm-3.217-3.656V57.5c.994.461,1.967,1.906,2.583,4.01A14.4,14.4,0,0,1,1240.084,61.858Zm-1.436-4.315v4.315a14.484,14.484,0,0,1-2.5-.329C1236.743,59.474,1237.681,58.047,1238.648,57.543Zm0,5.752v2.218h-3.132a18.128,18.128,0,0,1,.3-2.595A15.875,15.875,0,0,0,1238.648,63.3Zm7.3-3.1a9.877,9.877,0,0,1-1.9.908,11.012,11.012,0,0,0-1.435-3.155A9.068,9.068,0,0,1,1245.949,60.2Zm-9.714-2.29a10.979,10.979,0,0,0-1.472,3.224,9.953,9.953,0,0,1-1.982-.934A9.063,9.063,0,0,1,1236.235,57.906Z"
                        transform="translate(-1228.878 -55.902)"
                      />
                    </svg>
                    {/*<span className='fs_16_bold'> JP </span>*/}
                    <Select
                      onChange={handleChange}
                      className="w-12 md:w-16 text-right md:text-left"
                      style={{
                        borderRadius: "12px",
                        fontWeight: "700",
                        fontSize: "18px",
                        color: "#333333",
                        userSelect: "text",
                      }}
                      value={collectionId}
                      key={collectionId}
                      bordered={false}
                      showArrow={false}>
                      <option onClick={onChangeToJP} value={1} key={1}>
                        <span style={{ userSelect: "text" }}>JP</span>
                      </option>
                      <option onClick={onChangeToEN} value={2} key={2}>
                        <span style={{ userSelect: "text" }}>EN</span>
                      </option>
                      <option onClick={onChangeToZH} value={3} key={3}>
                        <span style={{ userSelect: "text" }}>ZH</span>
                      </option>
                    </Select>
                    </div>
                  </div>
                  {ctx.width < 768 ? (
                    <></>
                  ) : (
                    <>
                      {accountState.isLogin ? (
                        <>
                          <div className="inline-block bg-neutral-200  border-solid border-white rounded-full font-semibold mr-2">
                            <div className="flex w-full h-full justify-center items-center">
                              <div className="inline-block pl-4" style={{ verticalAlign: "middle" }}>
                                <Wallet />
                                {/* {accountState.avatarUrl ?
                                <img src={accountState.avatarUrl}
                                     alt="Avatar"
                                     className=" rounded-full object-cover "
                                     style={{width: '2.6rem', height: '2.6rem'}}
                                     loading="lazy"/>
                                :
                                <></>
                            } */}
                              </div>
                              <div
                                className="inline-block truncate w-20 p-1"
                                style={{ verticalAlign: "middle", userSelect: "text" }}>
                                {accountState.address}
                              </div>
                              <div style={{ userSelect: "text" }}>
                                <button
                                  className="inline-block bg-jpnft-buttonTo w-32 h-8 rounded-3xl"
                                  style={{ textAlign: "center", paddingTop: "3px" }}
                                  onClick={() => navigate(RoutePaths.MY_PAGE)}>
                                  <span className="text-lg text-white font-bold">{t("page.HOME_myPage")}</span>
                                </button>
                              </div>
                            </div>
                          </div>
                        </>
                      ) : (
                        <button
                          className="inline-block bg-gradient-to-r from-jpnft-buttonFrom to-jpnft-buttonTo w-48 h-8 rounded-3xl"
                          style={{ textAlign: "center" }}
                          onClick={() => connectWallet()}>
                          <span className="text-lg text-white font-bold">{t("page.HOME_connect")}</span>
                        </button>
                      )}
                    </>
                  )}
                </div>
              </Col>
            </Row>
          </div>
        </header>
      )}
    </Consumer>
  );
};
export default Header;
